import { createAction, props } from '@ngrx/store';
export const setFundChartZoom = createAction('[Fund Chart] Set chart zoom', props());
